import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SideNavDesktopComponent } from './side-nav-desktop/side-nav-desktop.component';
import { SideNavMobileComponent } from './side-nav-mobile/side-nav-mobile.component';

@Component({
  selector: 'app-side-nav',
  imports: [SideNavDesktopComponent, SideNavMobileComponent],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
})
export class SideNavComponent {
  private breakpointObserver = inject(BreakpointObserver);

  isDesktopSize = signal(window.innerWidth >= 768);

  constructor() {
    this.breakpointObserver
      .observe(['(min-width: 768px)'])
      .pipe(takeUntilDestroyed())
      .subscribe((result) => {
        this.isDesktopSize.set(result.matches);
      });
  }
}
